import React, { useState, useEffect } from 'react';
import { Activity, RefreshCw } from 'lucide-react';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import api from '../../services/api';

const ActivityLogs = () => {
  const [logs, setLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loadLogs();
  }, []);

  const loadLogs = async () => {
    setIsLoading(true);
    try {
      const response = await api.get('/activity-logs');
      setLogs(response.data);
    } catch (error) {
      toast.error('Erreur lors du chargement des logs');
    } finally {
      setIsLoading(false);
    }
  };

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleString('fr-FR');
  };

  const getActionColor = (action) => {
    if (action.includes('LOGIN')) return 'text-green-400';
    if (action.includes('CREATED') || action.includes('ADDED')) return 'text-blue-400';
    if (action.includes('DELETED')) return 'text-red-400';
    if (action.includes('UPDATED')) return 'text-yellow-400';
    return 'text-gray-400';
  };

  return (
    <div className="glass rounded-2xl p-6 shadow-xl border border-slate-700/50 animate-fadeIn">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Activity className="w-6 h-6 text-blue-400" />
          <h2 className="text-2xl font-bold text-white">Logs d'Activité</h2>
        </div>
        <Button
          onClick={loadLogs}
          disabled={isLoading}
          size="sm"
          className="bg-blue-600 hover:bg-blue-700"
          data-testid="refresh-logs-btn"
        >
          <RefreshCw className={`w-4 h-4 mr-2 ${isLoading ? 'animate-spin' : ''}`} />
          Actualiser
        </Button>
      </div>

      <div className="space-y-2 max-h-[600px] overflow-y-auto">
        {logs.length === 0 ? (
          <p className="text-gray-400 text-center py-8" data-testid="no-logs-msg">
            Aucun log disponible
          </p>
        ) : (
          logs.map((log) => (
            <div
              key={log.id}
              className="bg-slate-700/30 rounded-lg p-4 hover:bg-slate-700/50 transition-colors"
              data-testid={`log-item-${log.id}`}
            >
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <p className={`font-semibold ${getActionColor(log.action)}`}>
                    {log.action.replace(/_/g, ' ')}
                  </p>
                  {log.details && (
                    <p className="text-sm text-gray-400 mt-1">{log.details}</p>
                  )}
                  {log.ip_address && (
                    <p className="text-xs text-gray-500 mt-1">IP: {log.ip_address}</p>
                  )}
                </div>
                <p className="text-sm text-gray-400 ml-4 whitespace-nowrap">
                  {formatDate(log.timestamp)}
                </p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ActivityLogs;
